import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GatewayDTO } from '../../../../core/models/gateway';

@Component({
  selector: 'app-add-gateway',
  templateUrl: './add-gateway.component.html',
  styleUrls: ['./add-gateway.component.scss']
})
export class AddGatewayComponent implements OnInit {
  addGatewayForm: UntypedFormGroup;
  constructor(public dialog: MatDialogRef<AddGatewayComponent>) { }

  ngOnInit(): void {
    this.addGatewayForm = new UntypedFormGroup({
      addGatewayName: new UntypedFormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z_0-9-]*$/)]),
      addGatewayIP: new UntypedFormControl('', [Validators.required, Validators.pattern('(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)')]),
      addGatewayPort: new UntypedFormControl('', [Validators.required, Validators.pattern(/^[0-9]*$/)]),
    });
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit(form) {
    if (!form.valid) {
      return;
    } else {
        let gw: GatewayDTO = {
          name: form.value.addGatewayName,
          ip: form.value.addGatewayIP,
          port: form.value.addGatewayPort
        }
        this.dialog.close(gw);
    }
  }
}
